/** Traduce estados de suscripción/licencia del backend. */
export function translateStatus(status, t) {
  if (!status) return '';
  const key = String(status).toLowerCase();
  const map = {
    activo: ['status.activo', 'Activo'],
    vigente: ['status.vigente', 'Vigente'],
    por_vencer: ['status.por_vencer', 'Por vencer'],
    pendiente: ['status.pendiente', 'Pendiente'],
    pendiente_sede: ['status.pendiente_sede', 'Pago en sede pendiente'],
    pendiente_pago_online: ['status.pendiente_pago_online', 'Pago en línea pendiente'],
    vencido: ['status.vencido', 'Vencido'],
    cancelado: ['status.cancelado', 'Cancelado'],
    en_proceso: ['status.en_proceso', 'En proceso'],
    rechazado: ['status.rechazado', 'Rechazado'],
    active: ['status.active', 'Activo'],
    published: ['status.published', 'Publicado'],
  };
  const entry = map[key];
  if (entry) return t(entry[0], entry[1]);
  return t(`status.${key}`, String(status).replace(/_/g, ' '));
}

export function translateServiceLabel(service, fallback, t) {
  const map = {
    d28d: ['service.d28d', 'Fit Live · Programa'],
    food: ['service.food', 'FOOD PLAN'],
    training: ['service.training', 'TRAINING'],
  };
  const entry = map[service];
  if (entry) return t(entry[0], entry[1]);
  return fallback || service;
}

export function translatePaymentMethod(id, fallback, t) {
  const map = {
    wompi_online: ['payment.wompi_online', 'Pago en línea (Wompi)'],
    pago_sede: ['payment.pago_sede', 'Pago en sede'],
    pago_pendiente: ['payment.pago_pendiente', 'Pago pendiente (activar manual)'],
  };
  const entry = map[id];
  if (entry) return t(entry[0], entry[1]);
  return fallback || id;
}

export function formatLocaleDate(value, lang) {
  if (!value) return '';
  try {
    const locale = lang === 'en' ? 'en-US' : 'es-CO';
    return new Date(value).toLocaleDateString(locale);
  } catch {
    return '';
  }
}

export function translateTrafficLight(color, t) {
  const key = String(color || '').toLowerCase();
  const map = {
    green: ['d28d.progress.traffic.green', 'Verde'],
    yellow: ['d28d.progress.traffic.yellow', 'Amarillo'],
    red: ['d28d.progress.traffic.red', 'Rojo'],
  };
  const entry = map[key];
  if (entry) return t(entry[0], entry[1]);
  return color || '';
}
